<template>
    <new-address-form-base :countries="countries">
        <template slot-scope="{ newAddressType, setNewAddressType, address, errors, create }">
            <div class="card">
                <div class="card-body py-0">
                    <div class="form-row">
                        <div class="form-group col-md">
                            <label for="address-name">{{ __('Address name') }}</label>
                            <input
                                id="address-name"
                                v-model="address.name"
                                type="text"
                                class="form-control"
                            >
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-md">
                            <label for="billing-name">{{ __('Billing name') }}</label>
                            <input
                                id="billing-name"
                                v-model="address.billingName"
                                type="text"
                                class="form-control"
                            >
                        </div>
                        <div class="form-group col-md">
                            <label for="tax-number">{{ __('Tax number') }}</label>
                            <input
                                id="tax-number"
                                v-model="address.taxNumber"
                                type="text"
                                class="form-control"
                            >
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-md">
                            <label
                                for="city"
                                class="label-required"
                            >{{ __('City') }}</label>
                            <input
                                id="city"
                                v-model="address.city"
                                type="text"
                                class="form-control"
                                required
                            >
                            <form-error
                                field="city"
                                :errors="errors"
                            />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-8">
                            <label
                                for="street"
                                class="label-required"
                            >{{ __('Street') }}</label>
                            <input
                                id="street"
                                v-model="address.street"
                                type="text"
                                class="form-control"
                                required
                            >
                            <form-error
                                field="street"
                                :errors="errors"
                            />
                        </div>
                        <div class="form-group col-md-4">
                            <label
                                for="house-number"
                                class="label-required"
                            >{{ __('House number') }}</label>
                            <input
                                id="house-number"
                                v-model="address.houseNumber"
                                type="text"
                                class="form-control"
                                required
                            >
                            <form-error
                                field="houseNumber"
                                :errors="errors"
                            />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md">
                            <label
                                for="pots-code"
                                class="label-required"
                            >{{ __('Post code') }}</label>
                            <input
                                id="pots-code"
                                v-model="address.postCode"
                                type="text"
                                class="form-control"
                                required
                            >
                            <form-error
                                field="postCode"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <button
                        class="btn btn-primary"
                        @click="createBillingAddress(setNewAddressType, create)"
                    >
                        {{ __('Save') }}
                    </button>
                </div>
            </div>
        </template>
    </new-address-form-base>
</template>

<script>
export default {
    name: 'NewBillingAddressForm',
    props: {
        countries: {
            type: Array,
            required: true
        }
    },

    methods: {
        async createBillingAddress(setAddressType, create) {
            setAddressType('billing')
            const address = await create()

            if (address) {
                this.$emit('created', address)
            }
        }
    }
}
</script>
